import { useState } from "react";
import { Link } from "react-router-dom";
import { ITraining } from "../../../store/@types/training";

type ITrainingCard = {
  training: ITraining;
};

export const TrainingCard = ({ training }: ITrainingCard) => {
  const [imageFailed, setImageFailed] = useState(false);

  return (
    <Link
      to={`/training/${training.id}`}
      aria-label={`View details for ${training.name}`}
      className="block rounded-2xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600"
    >
      <article className="overflow-hidden rounded-2xl border border-gray-50/10 bg-white text-stone-900 shadow-sm transition-shadow hover:shadow-md">
        <div className="aspect-[16/9] bg-gray-100/10">
          {!imageFailed && training.image ? (
            <img
              src={training.image}
              alt=""
              loading="lazy"
              onError={() => setImageFailed(true)}
              className="h-full w-full object-cover"
            />
          ) : (
            <div className="flex h-full w-full items-center justify-center bg-gradient-to-br border-gray-50/10 to-gray-100 px-6 text-center text-sm font-medium text-stone-500">
              {training.name}
            </div>
          )}
        </div>

        <div className="space-y-3 p-5">
          <h3 className="text-lg font-semibold leading-snug tracking-tight">
            {training.name}
          </h3>

          <div className="flex items-center justify-between gap-4 border-t border-gray-50/10 pt-3">
            <p className="text-lg font-semibold tabular-nums">
              {training.amount}
            </p>
            {training.duration && (
              <p className="text-sm text-stone-600">
                <span className="sr-only">Duration: </span>
                {training.duration}
              </p>
            )}
          </div>
        </div>
      </article>
    </Link>
  );
};
export default TrainingCard;
